import ReactDOM from 'react-dom/client';
import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import app from './app';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
